/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link, useNavigate } from "react-router-dom";
import svgPaths from "../imports/svg-cwxh2va60v";
import imgImage1 from "../assets/0aec2039a323dfae679995f97066353c7b72b5eb.png";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import { toast } from "sonner";
import apiClient from "../api/client";

export default function Footer() {
   const {siteData: data} = useAuth()
   const navigate = useNavigate();

   const [newsLetterForm, setNewsLetterForm] = useState<{email: string}>({
      email: "",
   })
   const [errors, setErrors] = useState<Partial<typeof newsLetterForm>>({});
   const [loading, setLoading] = useState(false);

   const validateContactForm = () => {
      const errors: Partial<typeof newsLetterForm> = {};

      if (!newsLetterForm.email.trim()) {
         errors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newsLetterForm.email)) {
         errors.email = "Enter a valid email address";
      }

      return errors;
   };

   const handleSubscribe=async()=>{
      const errors = validateContactForm();
      if (Object.keys(errors).length > 0) {
         setErrors(errors);
         return;
      }
      setErrors({}); // can i put this line here ???

      setLoading(true)
      try{
         const {data} = await apiClient.post(`/schedules/subscribe`, {email: newsLetterForm.email})

         if(data?.success){
            toast.success(data?.message);
            setNewsLetterForm({email: ""});
         }
         else{
            toast.error(data?.message || "Error while subscribing...")
         }
      }
      catch(error: any){
         toast.error(error?.response?.data?.message || error?.message)
      }
      finally{
         setLoading(false)
      }
   }

   const scrollToSection = (sectionId: string) => {
      if (window.location.pathname !== '/') {
         navigate('/');
         setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            }
         }, 100);
      } else {
      const element = document.getElementById(sectionId);
         if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
         }
      }
   };

   return (
      // <footer className="bg-gradient-to-b from-[#042033] to-black text-white pt-20 pb-8 px-4">
      <footer className="bg-linear-to-b from-black to-[#042033] text-white pt-20 pb-8 px-4">
         <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-20">
               {/* Brand */}
               <div className="lg:col-span-1">
                  <div className="flex items-center gap-3 mb-6">
                     <Link to={`/`}>
                        <img src={data ? data?.footerLogo : imgImage1} alt="Logo" className="w-12 h-16 object-contain" />
                     </Link>
                     <Link to={'/'} className="font-semibold text-lg">
                        {data ? data?.name : "Akaram Radio"}
                     </Link>
                  </div>
                  <p className="text-white/60 text-sm mb-6 leading-relaxed">
                     {data ? data?.description : "Your Sound. Your Station. Broadcasting the best music and entertainment 24/7."}
                  </p>
                  <div className="flex gap-3">
                     {
                        data?.socialLinks?.facebook &&
                        <Link target="_blank" to={`${data?.socialLinks?.facebook ? data?.socialLinks?.facebook : '#'}`} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors group">
                           <Facebook className="w-4 h-4 text-[#174868] group-hover:text-white" />
                        </Link>
                     }
                     {
                        data?.socialLinks?.instagram &&
                        <Link target="_blank" to={`${data?.socialLinks?.instagram ? data?.socialLinks?.instagram : '#'}`} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors group">
                           <Instagram className="w-4 h-4 text-[#174868] group-hover:text-white" />
                        </Link>
                     }
                     {
                        data?.socialLinks?.twitter &&
                        <Link target="_blank" to={`${data?.socialLinks?.twitter ? data?.socialLinks?.twitter : '#'}`} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors group">
                           <Twitter className="w-4 h-4 text-[#174868] group-hover:text-white" />
                        </Link>
                     }
                  </div>
               </div>

               {/* Quick Links */}
               <div>
                  <h4 className="font-medium text-base mb-6">Quick Links</h4>
                  <ul className="space-y-4 text-white/60">
                     <li><button onClick={()=>{scrollToSection('home')}} className="hover:text-white transition-colors cursor-pointer">Home</button></li>
                     <li><button onClick={()=>{scrollToSection('schedule')}} className="hover:text-white transition-colors cursor-pointer">Schedule</button></li>
                     <li><button onClick={()=>{scrollToSection('shows')}} className="hover:text-white transition-colors cursor-pointer">Shows</button></li>
                     <li><button onClick={()=>{scrollToSection('contact')}} className="hover:text-white transition-colors cursor-pointer">Contact</button></li>
                     {/* <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li> */}
                     {/* <li><Link to="/admin/login" className="hover:text-white transition-colors">Admin Login</Link></li> */}
                  </ul>
               </div>

               {/* Contact */}
               <div>
                  <h4 className="font-medium text-base mb-6">Contact Us</h4>
                  <ul className="space-y-4 text-white/60 text-sm">
                     <li className="flex gap-3">
                        <svg className="w-4 h-4 shrink-0" viewBox="0 0 16 16" fill="none" stroke="currentColor">
                           <path d={svgPaths.p26187580} strokeWidth="1.3" strokeOpacity="0.6" />
                        </svg>
                        <div className="flex flex-col">
                        {
                           data && data?.phones?.map((e: any, i: number)=> {
                              return (
                                 <div key={i}>
                                    <span>{e}</span>
                                 </div>
                              )
                              })
                        }
                        </div>
                        {/* <span>+47 40 24 94 94,<br />+47 40 09 98 98</span> */}
                     </li>
                     <li className="flex gap-3">
                        <svg className="w-4 h-4 shrink-0" viewBox="0 0 16 16" fill="none" stroke="currentColor">
                           <path d={svgPaths.p2f8e7e80} strokeWidth="1.3" strokeOpacity="0.6" />
                           <path d={svgPaths.p17070980} strokeWidth="1.3" strokeOpacity="0.6" />
                        </svg>
                        <span>{data ? data?.email : "akaram.radio@gmail.com"}</span>
                     </li>
                  </ul>
               </div>

               {/* Newsletter */}
               <div>
                  <h4 className="font-medium text-base mb-6">Newsletter</h4>
                  <p className="text-white/60 text-sm mb-4">Stay updated with our latest shows and events.</p>
                  <div className="flex gap-2">
                     <input
                        type="text"
                        placeholder="Your email"
                        value={newsLetterForm.email}
                        onChange={(e)=>{setNewsLetterForm({email: e.target.value})}}
                        className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm text-white placeholder:text-white/40 w-full focus:outline-none focus:border-cyan-500"
                     />
                     <button onClick={handleSubscribe} className="bg-gradient-to-b from-[#174868] to-[#147b89] text-white px-4 py-2 rounded-lg text-sm font-medium hover:brightness-110 transition-all">
                        {/* Subscribe */}
                        {
                           loading ? 
                           <div className="flex gap-2"><SmallLoader /> Subscribing... </div> : 
                           <>Subscribe </>
                        }
                     </button>
                  </div>
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
               </div>

               {/* Download App */}
               <div>
                  <h4 className="font-medium text-base mb-6">Download Our App</h4>
                  <p className="text-white/60 text-sm mb-4">Listen on the go with our mobile app.</p>
                  <div className="space-y-3">
                     <Link target="_blank" to={"https://apps.apple.com/in/app/akaram-radio-norway/id1337173677"} className="w-full bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl p-3 flex items-center gap-3 transition-colors text-left">
                        <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d={svgPaths.p190aeb00} strokeLinecap="round" strokeLinejoin="round" />
                           <path d={svgPaths.p673c500} strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <div>
                           <div className="text-[10px] text-white/60 uppercase">Download on the</div>
                           <div className="text-sm font-medium text-white">App Store</div>
                        </div>
                     </Link>
                     <Link target="_blank" to={"https://play.google.com/store/apps/details?id=act.eminence.akram"} className="w-full bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl p-3 flex items-center gap-3 transition-colors text-left">
                        <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d={svgPaths.p1adf7700} strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M12 18H12.01" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <div>
                           <div className="text-[10px] text-white/60 uppercase">Get it on</div>
                           <div className="text-sm font-medium text-white">Google Play</div>
                        </div>
                     </Link>
                  </div>
               </div>
            </div>

            <div className="border-t border-white/10 pt-8 text-center">
               <p className="text-white/40 text-sm">© {new Date().getFullYear()} Akaram.no All rights reserved.</p>
            </div>
         </div>
      </footer>
   );
}

export const SmallLoader=()=>{
  return <div className="w-4 h-4 border-2 border-white/80 border-t-transparent rounded-full animate-spin"></div>

}